import { render, staticRenderFns } from "./ProduccionItem.vue?vue&type=template&id=458da76a&scoped=true"
import script from "./ProduccionItem.vue?vue&type=script&lang=js"
export * from "./ProduccionItem.vue?vue&type=script&lang=js"
import style0 from "./ProduccionItem.vue?vue&type=style&index=0&id=458da76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458da76a",
  null
  
)

export default component.exports